import React, { ChangeEvent } from "react";
import "./Toggle.css";

interface ToggleProps {
  id: string;
  checked?: boolean;
  defaultChecked?: boolean;
  disabled?: boolean;
  className?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const Toggle = (props: ToggleProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (props.onChange) {
      props.onChange(event);
    }
  };

  return (
    <label
      className={`toggle ${props.className || ""} ${
        props.disabled ? "toggle--disabled" : ""
      }`}
      htmlFor={props.id}
    >
      <input
        type="checkbox"
        id={props.id}
        className="toggle-input"
        checked={props.checked}
        defaultChecked={props.defaultChecked}
        disabled={props.disabled}
        onChange={handleChange}
      />
      <span className="toggle-track">
        <span className="toggle-thumb" />
      </span>
    </label>
  );
};

export default Toggle;
